import { Container, Row, Col, Card, CardHeader, Table, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from 'reactstrap';
import React, { useState } from 'react';
import { H3 } from 'AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import { updateSetupSchedule } from 'Services/Features/SetupSchedule/Utils/setupScheduleUtils';
import { useParams } from 'react-router-dom';

const CalendarGrid = ({ data }) => {
    const { id } = useParams();
    const user = JSON.parse(localStorage.getItem('USER'));
    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [selectedDate, setSelectedDate] = useState('');
    const [inputQuota, setInputQuota] = useState('');
    const handleBadgeClick = (slotItem, date) => {
        setSelectedSlot(slotItem);
        setSelectedDate(date);
        setInputQuota(slotItem.quota);
        setModalOpen(true);
    };
    const handleSubmit = () => {
        // Lakukan aksi submit di sini, misal update quota
        // Contoh: dispatch(updateQuota(selectedSlot.id, inputQuota));
        const payload = {
            schedule_id: selectedSlot.id,
            quota: inputQuota,
        };
        dispatch(updateSetupSchedule({ branch_id: id ? id : user.branch_id, data: payload }))
        setModalOpen(false);
    };

    const handleCancel = () => {
        setModalOpen(false);
    };
    // Ambil semua jam unik untuk dijadikan baris
    const getTimeSlots = () => {
        const slots = new Set();
        Object.values(data).forEach((day) => {
            day.forEach((slot) => {
                slots.add(`${slot.hour_start_at} - ${slot.hour_end_at}`);
            });
        });
        return Array.from(slots).sort();
    };

    const formatDateSimple = (dateString) => {
        return dateString.split(" ")[0]; // Ambil bagian sebelum spasi
    };

    const timeSlots = getTimeSlots();
    const dates = Object.keys(data).sort((a, b) => new Date(a) - new Date(b));

    return (
        <Container fluid={true}>
            <Modal isOpen={modalOpen} toggle={handleCancel}>
                <ModalHeader toggle={handleCancel}>UPDATE KUOTA JADWAL</ModalHeader>
                <ModalBody>
                    {selectedSlot && (
                        <div style={{ display: 'flex', gap: 24 }}>
                            {/* Kolom Kiri: Info Jadwal */}
                            <div style={{ flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <i className="fa fa-hashtag me-2 text-primary" /> {/* ID Icon */}
                                    <span style={{ minWidth: 90, fontWeight: 'bold' }}>ID Jadwal</span>
                                    <span style={{ minWidth: 10, textAlign: 'center' }}>:</span>
                                    <span>{selectedSlot.id}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <i className="fa fa-calendar me-2 text-success" /> {/* Calendar Icon */}
                                    <span style={{ minWidth: 90, fontWeight: 'bold' }}>Tanggal</span>
                                    <span style={{ minWidth: 10, textAlign: 'center' }}>:</span>
                                    <span>{selectedDate && formatDateSimple(selectedDate)}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <i className="fa fa-clock-o me-2 text-info" /> {/* Clock Icon */}
                                    <span style={{ minWidth: 90, fontWeight: 'bold' }}>Jam Mulai</span>
                                    <span style={{ minWidth: 10, textAlign: 'center' }}>:</span>
                                    <span>{selectedSlot.hour_start_at}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <i className="fa fa-clock-o me-2 text-info" /> {/* Clock Icon */}
                                    <span style={{ minWidth: 90, fontWeight: 'bold' }}>Jam Selesai</span>
                                    <span style={{ minWidth: 10, textAlign: 'center' }}>:</span>
                                    <span>{selectedSlot.hour_end_at}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <i className="fa fa-users me-1 text-warning" /> {/* Users Icon */}
                                    <span style={{ minWidth: 90, fontWeight: 'bold' }}>Kuota Saat Ini</span>
                                    <span style={{ minWidth: 10, textAlign: 'center' }}>:</span>
                                    <span>{selectedSlot.quota}</span>
                                </div>
                            </div>
                            {/* Kolom Kanan: Form Ubah Kuota */}
                            <div style={{
                                flex: 1,
                                background: '#f8f9fa',
                                borderRadius: 8,
                                padding: 16,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <label style={{ fontWeight: 'bold', marginBottom: 8 }}>
                                    <i className="fa fa-edit me-2 text-secondary" />
                                    Ubah Kuota
                                </label>
                                <Input
                                    type="number"
                                    value={inputQuota}
                                    onChange={e => setInputQuota(e.target.value)}
                                    min={0}
                                    onWheel={e => e.target.blur()}
                                    style={{ width: 100, textAlign: 'center', marginBottom: 12 }}
                                />
                                <Button color="primary" onClick={handleSubmit} style={{ width: '100%' }}>Update</Button>
                                <Button color="secondary" onClick={handleCancel} style={{ width: '100%', marginTop: 8 }}>Cancel</Button>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>
            <Row>
                <Col sm="12" lg="12" xl="12">
                    <Card>
                        <CardHeader className="pb-3 text-center">
                            <H3>Jadwal Cabang</H3>
                        </CardHeader>
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive">
                                {dates.length > 0 ? (
                                    <Table className="table-hover table-border-vertical">
                                        <thead className="bg-primary">
                                            <tr>
                                                <th scope="col" style={{ width: "160px" }} className="text-center sticky-col-slot">
                                                    Jam
                                                </th>
                                                {dates.map((date) => (
                                                    <th scope="col" key={date} className="text-center">
                                                        {formatDateSimple(date)}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {timeSlots.map((slot, index) => (
                                                <tr key={index}>
                                                    <td className="text-center sticky-col-slot" style={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                                                        {slot}
                                                    </td>
                                                    {dates.map((date) => (
                                                        <td key={date} className="text-center">
                                                            {data[date]?.some(
                                                                (item) => `${item.hour_start_at} - ${item.hour_end_at}` === slot
                                                            ) ? (
                                                                <Badge
                                                                    color={
                                                                        data[date].find(
                                                                            (item) => `${item.hour_start_at} - ${item.hour_end_at}` === slot
                                                                        )?.quota <= 5
                                                                            ? 'danger'
                                                                            : data[date].find(
                                                                                (item) => `${item.hour_start_at} - ${item.hour_end_at}` === slot
                                                                            )?.quota <= 10
                                                                                ? 'warning'
                                                                                : 'success'
                                                                    }
                                                                        onClick={() => handleBadgeClick(
                                                                            data[date].find((item) => `${item.hour_start_at} - ${item.hour_end_at}` === slot),
                                                                            date
                                                                        )} 
                                                                        style={{ cursor: 'pointer' }}
                                                                >
                                                                    Tersedia {data[date].find((item) => `${item.hour_start_at} - ${item.hour_end_at}` === slot)?.quota} kuota
                                                                </Badge>
                                                            ) : (
                                                                <>-</>
                                                            )}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <div className="text-center p-4">
                                        <Badge color="danger">Tidak ada data jadwal tersedia!</Badge>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CalendarGrid;
